import styled from 'styled-components';

import type {
  PurchaseWebCampaignOffer,
  ProductType,
  PurchaseWebTextValues,
} from '@xing-com/crate-common-graphql-types';
import { DiscountBubble } from '@xing-com/crate-upsell-discount-bubble';
import { VisuallyHidden } from '@xing-com/crate-upsell-layouts';
import type { ContractPrice } from '@xing-com/crate-upsell-utils';
import { spaceS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { Headline } from '../headline';

import { CountdownBubble } from './countdown-bubble';

export type OfferBoxHeaderProps = Pick<PurchaseWebCampaignOffer, 'endsAt'> & {
  product: ProductType;
  textValues: PurchaseWebTextValues;
  price: ContractPrice;
  className?: string;
  hideSubheading?: boolean;
};

export const OfferBoxHeader: React.FC<OfferBoxHeaderProps> = ({
  product,
  textValues,
  endsAt,
  price,
  className = '',
  hideSubheading = false,
}) => {
  return (
    <HeaderWrapper className={className}>
      <div>
        <Headline product={product} />
        {hideSubheading
          ? null
          : textValues.subheading.trim().length > 0 && (
              <BodyCopy
                size="medium"
                sizeWide="xlarge"
                lineHeight="dense"
                noMargin
              >
                {textValues.subheading}
              </BodyCopy>
            )}
      </div>
      <BubblesWrapper>
        {endsAt !== null && endsAt !== undefined && endsAt !== '' ? (
          <CountdownBubble endDate={new Date(endsAt)} />
        ) : null}
        <VisuallyHidden hasException={price.discount !== 0}>
          <DiscountBubble
            withAsterisk
            percentage={price.discount}
            product={product}
            discountBubbleMessage="UPSELL_PURCHASE_DISCOUNT_BUBBLE_MESSAGE"
          />
        </VisuallyHidden>
      </BubblesWrapper>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const BubblesWrapper = styled.div`
  display: grid;
  gap: ${spaceS};
`;
